import { AppError } from "../errorHandling";


export enum HttpErrorCode {
    NetworkError = "NetworkError",
    JsonDataError = "JsonDataError",
    ResponseError = "ResponseError",
}

export class HttpError extends AppError {
    private _url: string;
    private _statusCode: number;
    private _method: string;


    constructor(source: string, errorCode: HttpErrorCode, userMessage: string, url: string, method:string, statusCode: number, stack?: string, innerError?: Error) {
        super(source, errorCode, userMessage, stack, innerError);

        this._url = url;
        this._method = method;
        this._statusCode = statusCode;

    }

    public get url() {
        return this._url;
    }

    public get statusCode() {
        return this._statusCode;
    }

    public get method() {
        return this._method;
    }


    public isHttpError() {
        return true;
    }

    protected prepareForJson(): any {
        const res = super.prepareForJson();
        res.url = this.url;
        res.method = this.method;
        res.statusCode = this.statusCode;
        return res;
    }
}

